import React, { useEffect, useRef, useState } from "react";
import { Wheel } from "react-custom-roulette";
import axios from "axios";

/* ---------------- WHEEL DATA ---------------- */
const data = [
  { option: "Home Appliances" },
  { option: "Electronics" },
  { option: "Silver" },
  { option: "Gold" },
  { option: "Home Appliances" },
  { option: "Electronics" },
  { option: "Silver" },
  { option: "Home Appliances" },
  { option: "Gold" },
  { option: "Electronics" },
];

/* ---------------- API CONFIGURATION ---------------- */
const WHATSAPP_API_URL =
  "https://live-mt-server.wati.io/324370/api/v1/sendTemplateMessage";
// const WHATSAPP_API_TOKEN =
//   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImhyQGdwaG9tZXMuY28uaW4iLCJuYW1laWQiOiJockBncGhvbWVzLmNvLmluIiwiZW1haWwiOiJockBncGhvbWVzLmNvLmluIiwiYXV0aF90aW1lIjoiMDIvMDkvMjAyNiAwNzo1NzowMCIsInRlbmFudF9pZCI6IjMyNDM3MCIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTklTVFJBVE9SIiwiZXhwIjoyNTM0MDIzMDA4MDAsImlzcyI6IkNsYXJlX0FJIiwiYXVkIjoiQ2xhcmVfQUkifQ.rxVUIB-ReGGkTiMfVmmCb0wSCORvM68nYbMYhgNrOCA";
const WHATSAPP_API_TOKEN =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6ImhyQGdwaG9tZXMuY28uaW4iLCJuYW1laWQiOiJockBncGhvbWVzLmNvLmluIiwiZW1haWwiOiJockBncGhvbWVzLmNvLmluIiwiYXV0aF90aW1lIjoiMDIvMjAvMjAyNiAwNTo1MDowNiIsInRlbmFudF9pZCI6IjMyNDM3MCIsImRiX25hbWUiOiJtdC1wcm9kLVRlbmFudHMiLCJodHRwOi8vc2NoZW1hcy5taWNyb3NvZnQuY29tL3dzLzIwMDgvMDYvaWRlbnRpdHkvY2xhaW1zL3JvbGUiOiJBRE1JTklTVFJBVE9SIiwiZXhwIjoyNTM0MDIzMDA4MDAsImlzcyI6IkNsYXJlX0FJIiwiYXVkIjoiQ2xhcmVfQUkifQ.ROvSKimagXI9xuhgeRMJQG57m80vNMqS8eascrArPeA";

const BACKEND_API_URL = "https://cms.gphomes.in/api";

/* ---------------- HELPERS ---------------- */
const getRandomPrizeIndex = () => {
  // Generate a random number between 0 and data.length - 1
  return Math.floor(Math.random() * data.length);
};

const generateCouponCode = (category) => {
  const prefix = "GPH";
  const categoryCode = category.substring(0, 3).toUpperCase();
  const randomString = Math.random()
    .toString(36)
    .substring(2, 10)
    .toUpperCase();
  return `${prefix}-${categoryCode}-${randomString}`;
};

/* ---------------- COMPONENT ---------------- */
const SpinWheel = () => {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState("mobile");

  const [mobile, setMobile] = useState("");
  const [otpInput, setOtpInput] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState("");
  const [coupon, setCoupon] = useState("");
  const [copied, setCopied] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isValidatingPhone, setIsValidatingPhone] = useState(false);
  const [isSavingCoupon, setIsSavingCoupon] = useState(false);

  const [whatsAppStatus, setWhatsAppStatus] = useState("");
  /* 🔊 AUDIO REFS */
  const spinAudio = useRef(new Audio("/sounds/spin1.wav"));
  const winAudio = useRef(new Audio("/sounds/win.mp3"));

  /* ---------------- UPDATED BACKEND API FUNCTIONS ---------------- */

  const validatePhoneWithBackend = async (phoneNumber) => {
    try {
      setIsValidatingPhone(true);
      setError("");

      console.log("Validating phone:", phoneNumber);

      const response = await fetch(`${BACKEND_API_URL}/validate-phone`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
        },
        body: JSON.stringify({
          phone: phoneNumber,
        }),
      });

      const data = await response.json();
      console.log("Validation response:", data);

      // NEW USER: Status: "Success", Results: "Mobile number is not exists"
      if (
        data.Status === "Success" &&
        data.Results === "Mobile number is not exists"
      ) {
        return {
          success: true,
          isNewUser: true, // ✅ This is a NEW user
          message: "New user can proceed",
          data: data,
        };
      }

      // EXISTING USER: Status: "Failed", Message: "Mobile number already exists"
      if (
        data.Status === "Failed" &&
        data.Message === "Mobile number already exists"
      ) {
        return {
          success: true, // The API call itself succeeded
          isNewUser: false, // ❌ This is an EXISTING user
          message: data.Message,
          data: data,
        };
      }

      // OTHER ERRORS
      return {
        success: false,
        isNewUser: false,
        message: data.Message || data.Results || "Validation failed",
        data: data,
      };
    } catch (error) {
      console.error("Phone validation error:", error);
      return {
        success: false,
        isNewUser: false,
        message: "Validation failed. Please try again.",
        error: error.message,
      };
    } finally {
      setIsValidatingPhone(false);
    }
  };

  const saveCouponToBackend = async (phoneNumber, couponCode, category) => {
    try {
      setIsSavingCoupon(true);

      console.log("Saving coupon:", { phoneNumber, couponCode, category });

      const response = await fetch(`${BACKEND_API_URL}/coupon`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "gp-web-token": "sdswkhsADWRjfh9Thwn8rn6Mybd",
        },
        body: JSON.stringify({
          phone: phoneNumber,
          coupon_code: couponCode,
          category: category,
          campaign: "spin_wheel",
          source: "ponbhoomi_landing",
        }),
      });

      const data = await response.json();
      console.log("Coupon save response:", data);

      return {
        success: data.Status === "Success",
        message: data.Message || data.Results || "Coupon saved successfully",
      };
    } catch (error) {
      console.error("Coupon save error:", error);
      return {
        success: false,
        message: "Failed to save coupon. Please try again.",
      };
    } finally {
      setIsSavingCoupon(false);
    }
  };

  /* ---------------- WHATSAPP OTP FUNCTION ---------------- */
  const sendWhatsAppOtp = async (phoneNumber) => {
    try {
      setIsSendingOtp(true);
      setError("");

      // Generate a 6-digit OTP
      const otp = Math.floor(100000 + Math.random() * 900000);

      // Store OTP in localStorage for verification
      localStorage.setItem("otp", otp.toString());

      const fullPhoneNumber = `91${phoneNumber}`;

      const payload = {
        template_name: "contest_otp",
        broadcast_name: "OTP Verification",
        parameters: [
          {
            name: "1",
            value: `${otp}`,
          },
        ],
      };

      console.log("Sending WhatsApp OTP to:", fullPhoneNumber);
      console.log("Using template: contest_otp");
      console.log("OTP:", otp);

      const response = await axios.post(
        `${WHATSAPP_API_URL}?whatsappNumber=${fullPhoneNumber}`,
        payload,
        {
          headers: {
            Authorization: WHATSAPP_API_TOKEN,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("WhatsApp API Response:", response.data);

      if (response.data && response.data.result) {
        return {
          success: true,
          message: "OTP sent to your WhatsApp. Please check.",
        };
      } else {
        return {
          success: false,
          message: response.data?.message || "Failed to send OTP",
        };
      }
    } catch (error) {
      console.error("WhatsApp OTP Error:", error);
      console.error("Error details:", error.response?.data);

      return {
        success: false,
        message:
          error.response?.data?.Message ||
          error.response?.data?.error ||
          "Failed to send OTP. Please try again.",
      };
    } finally {
      setIsSendingOtp(false);
    }
  };

  /* ---------------- VERIFY OTP & PROCEED ---------------- */
  const verifyOtpAndProceed = () => {
    const storedOtp = localStorage.getItem("otp");
    console.log("Stored OTP:", storedOtp, "Entered OTP:", otpInput);

    if (otpInput === storedOtp) {
      // OTP verification successful
      localStorage.removeItem("otp");
      setShowPopup(false);
      setError("");

      setTimeout(() => {
        // Get random prize index (0 to data.length - 1)
        const randomIndex = getRandomPrizeIndex();

        setPrizeNumber(randomIndex);
        setResult(data[randomIndex].option);
        setMustSpin(true);

        if (spinAudio.current) {
          spinAudio.current.loop = true;
          spinAudio.current
            .play()
            .catch((e) => console.log("Audio play error:", e));
        }

        if (navigator.vibrate) navigator.vibrate(100);
      }, 300);
    } else {
      setError("Invalid OTP. Please try again.");
    }
  };

  /* ---------------- AFTER SPIN - SAVE COUPON ---------------- */
  const handleSpinEnd = async () => {
    setMustSpin(false);

    if (spinAudio.current) {
      spinAudio.current.pause();
      spinAudio.current.currentTime = 0;
    }

    const couponCode = generateCouponCode(result);
    console.log("Generated coupon:", couponCode, "for prize:", result);

    // Save coupon to backend
    const saveResult = await saveCouponToBackend(mobile, couponCode, result);
    console.log("Save result:", saveResult);

    if (saveResult && saveResult.success) {
      setCoupon(couponCode);

      // 🎯 AUTO SEND WHATSAPP MESSAGE FOR WINNER - UPDATED TEMPLATE
      try {
        console.log("Sending winner WhatsApp message to:", mobile);

        const fullPhoneNumber = `91${mobile}`;
        const payload = {
          template_name: "spin_result_notification",
          broadcast_name: "Spin Result Message",
          parameters: [
            { name: "1", value: result },
            { name: "2", value: couponCode },
          ],
        };

        const whatsappResponse = await axios.post(
          `${WHATSAPP_API_URL}?whatsappNumber=${fullPhoneNumber}`,
          payload,
          {
            headers: {
              Authorization: WHATSAPP_API_TOKEN,
              "Content-Type": "application/json",
            },
          },
        );

        console.log("WhatsApp winner message sent:", whatsappResponse.data);

        if (whatsappResponse.data && whatsappResponse.data.result) {
          setWhatsAppStatus("sent");
        } else {
          setWhatsAppStatus("failed");
          console.warn(
            "WhatsApp API returned non-success:",
            whatsappResponse.data,
          );
        }
      } catch (whatsappError) {
        console.error("Failed to send WhatsApp winner message:", whatsappError);
        console.error("Error details:", whatsappError.response?.data);
        setWhatsAppStatus("failed");
      }

      if (winAudio.current) {
        winAudio.current
          .play()
          .catch((e) => console.log("Win audio error:", e));
      }

      setStep("success");
      setShowPopup(true);

      if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
    } else {
      // Even if save fails, show coupon with error message
      setCoupon(couponCode);
      setError(`Error: ${saveResult?.message || "Failed to save coupon"}`);
      setStep("success");
      setShowPopup(true);
    }
  };

  /* ---------------- SPIN CLICK ---------------- */
  const handleSpinClick = () => {
    setShowPopup(true);
    setStep("mobile");
    setError("");
    setOtpInput("");
    setCoupon("");
    setResult("");
  };

  /* ---------------- UPDATED MOBILE SUBMIT ---------------- */
  const handleMobileSubmit = async () => {
    setError("");

    // Frontend validation
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setError("Enter valid 10-digit mobile number");
      return;
    }

    // Backend validation
    const validation = await validatePhoneWithBackend(mobile);
    console.log("Backend validation result:", validation);

    if (!validation.success) {
      setError(validation.message || "Phone validation failed");
      return;
    }

    // Check if user is NEW
    if (!validation.isNewUser) {
      // Show specific error message for existing users
      setError(
        "This phone number is already registered. Please use a different number.",
      );
      return;
    }

    // Send WhatsApp OTP only for NEW users
    const otpResult = await sendWhatsAppOtp(mobile);
    console.log("OTP send result:", otpResult);

    if (otpResult.success) {
      setStep("otp");
    } else {
      setError(otpResult.message);
    }
  };

  /* ---------------- VERIFY OTP CLICK ---------------- */
  const handleVerifyOtp = () => {
    setIsVerifyingOtp(true);
    setError("");

    if (!otpInput || otpInput.length !== 6) {
      setError("Please enter 6-digit OTP");
      setIsVerifyingOtp(false);
      return;
    }

    setTimeout(() => {
      verifyOtpAndProceed();
      setIsVerifyingOtp(false);
    }, 500);
  };

  /* ---------------- COPY COUPON ---------------- */
  const copyCoupon = () => {
    navigator.clipboard.writeText(coupon);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  /* ---------------- RESEND OTP ---------------- */
  const handleResendOtp = async () => {
    setError("");
    const result = await sendWhatsAppOtp(mobile);

    if (result.success) {
      setError("OTP resent successfully!");
      setOtpInput("");
    } else {
      setError(result.message);
    }
  };

  /* ---------------- CLOSE POPUP ---------------- */
  const onClose = () => {
    setShowPopup(false);
    setStep("mobile");
    setMobile("");
    setCoupon("");
    setResult("");
    setOtpInput("");
    setError("");
    setWhatsAppStatus(""); // Reset WhatsApp status
  };

  const spinBtnAnimation = {
    animation: "pulse 1.2s infinite",
  };

  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(
    `
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.12); }
  100% { transform: scale(1); }
}
`,
    styleSheet.cssRules.length,
  );

  useEffect(() => {
    if (showPopup) {
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.width = "";
    }
  }, [showPopup]);

  return (
    <div style={styles.page}>
      <div style={styles.wheelBox} className="wheelBox">
        <Wheel
          mustStartSpinning={mustSpin}
          prizeNumber={prizeNumber}
          data={data}
          backgroundColors={["#c81d1d", "#f6e7c3"]}
          textColors={["#ffffff", "#000000"]}
          outerBorderColor="#d4af37"
          outerBorderWidth={10}
          radiusLineColor="#000"
          radiusLineWidth={4}
          fontSize={17}
          fontWeight={900}
          textDistance={55}
          perpendicularText={false}
          spinDuration={0.6}
          onStopSpinning={handleSpinEnd}
          responsive={true}
        />
      </div>

      <button
        style={{
          ...styles.spinBtn,
          ...(!mustSpin ? spinBtnAnimation : {}),
          transform: mustSpin ? "scale(0.95)" : "scale(1)",
          transition: "transform 0.15s ease",
        }}
        onClick={handleSpinClick}
        onMouseDown={(e) => (e.currentTarget.style.transform = "scale(0.9)")}
        onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        SPIN
      </button>

      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.popup}>
            {step === "mobile" && (
              <>
                <span style={styles.closeIcon} onClick={onClose}>
                  ✕
                </span>
                <h2>Spin & Win 🎉</h2>
                <p style={{ fontSize: 14 }}>
                  Register your mobile number to create your coupon
                </p>

                <input
                  style={styles.input}
                  placeholder="Enter Mobile Number"
                  value={mobile}
                  maxLength={10}
                  onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
                  disabled={isSendingOtp || isValidatingPhone}
                />

                {error && <p style={styles.error}>{error}</p>}

                <button
                  style={styles.popupBtn}
                  onClick={handleMobileSubmit}
                  disabled={
                    isSendingOtp ||
                    isValidatingPhone ||
                    !mobile ||
                    mobile.length !== 10
                  }
                >
                  {isSendingOtp
                    ? "Sending OTP..."
                    : isValidatingPhone
                      ? "Validating..."
                      : "Send OTP"}
                </button>
              </>
            )}

            {step === "otp" && (
              <>
                <h2>OTP Verification</h2>
                <p>OTP sent to +91 {mobile} via WhatsApp</p>

                <input
                  style={styles.input}
                  placeholder="Enter 6-digit OTP"
                  value={otpInput}
                  maxLength={6}
                  onChange={(e) =>
                    setOtpInput(e.target.value.replace(/\D/g, ""))
                  }
                  disabled={isVerifyingOtp}
                />

                {error && (
                  <p
                    style={
                      error.includes("Invalid") || error.includes("Failed")
                        ? styles.error
                        : styles.success
                    }
                  >
                    {error}
                  </p>
                )}

                <div style={styles.otpActions}>
                  <button
                    style={styles.verifyBtn}
                    onClick={handleVerifyOtp}
                    disabled={
                      isVerifyingOtp || !otpInput || otpInput.length !== 6
                    }
                    className="verifyBtn"
                  >
                    {isVerifyingOtp ? "Verifying..." : "Verify OTP"}
                  </button>

                  <button
                    style={styles.resendBtn}
                    onClick={handleResendOtp}
                    disabled={isSendingOtp}
                  >
                    {isSendingOtp ? "Sending..." : "Resend OTP"}
                  </button>
                </div>

                <button
                  style={styles.backBtn}
                  onClick={() => {
                    setStep("mobile");
                    setError("");
                    setOtpInput("");
                  }}
                  disabled={isVerifyingOtp}
                >
                  Back
                </button>
              </>
            )}

            {step === "success" && (
              <>
                <h3>🎁 {error ? "Error" : "Coupon Generated"}</h3>

                {error ? (
                  <p style={{ color: "red", fontSize: 14, marginBottom: 10 }}>
                    ⚠️ {error}
                  </p>
                ) : (
                  <>
                    <p>
                      You won <b>{result}</b>
                    </p>

                    {/* WhatsApp Status Indicator */}
                    {whatsAppStatus === "sent" && (
                      <p
                        style={{ color: "#25D366", fontSize: 13, marginTop: 5 }}
                      >
                        ✓ Winner details sent to your WhatsApp
                      </p>
                    )}
                    {whatsAppStatus === "failed" && (
                      <p
                        style={{ color: "orange", fontSize: 13, marginTop: 5 }}
                      >
                        ⚠️ Could not send WhatsApp message. Please save your
                        coupon code.
                      </p>
                    )}
                  </>
                )}

                <div style={styles.couponBox} onClick={copyCoupon}>
                  <p style={styles.couponCode}>{coupon}</p>
                  <span style={styles.copyHint}>
                    {copied ? "Copied ✅" : "Tap to copy coupon code"}
                  </span>
                </div>

                {!error && (
                  <p
                    style={{
                      fontSize: 12,
                      color: "#4CAF50",
                      marginTop: 5,
                      fontWeight: "bold",
                    }}
                  >
                    ✓ Coupon saved successfully
                  </p>
                )}

                <button
                  style={styles.popupBtn}
                  onClick={onClose}
                  disabled={isSavingCoupon}
                >
                  {isSavingCoupon ? "Saving..." : "Close"}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* ---------------- STYLES ---------------- */
const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  spinBtn: {
    padding: "12px 36px",
    fontSize: 18,
    fontWeight: 700,
    borderRadius: 6,
    border: "none",
    cursor: "pointer",
    background: "linear-gradient(#ffd700, #b8860b)",
    boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 999,
    height: "100vh",
  },
  popup: {
    position: "relative", // 👈 ADD THIS
    width: "90%",
    maxWidth: 400,
    background: "#fff",
    padding: 25,
    borderRadius: 12,
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  },
  input: {
    width: "100%",
    padding: 12,
    marginTop: 15,
    fontSize: 16,
    borderRadius: 6,
    border: "1px solid #ddd",
    textAlign: "center",
    boxSizing: "border-box",
  },
  popupBtn: {
    marginTop: 20,
    padding: "12px 24px",
    fontSize: 16,
    background: "#ffd700",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    width: "100%",
    fontWeight: 600,
  },
  verifyBtn: {
    padding: "12px 24px",
    fontSize: 16,
    background: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontWeight: 600,
    flex: 2,
  },
  resendBtn: {
    padding: "12px 16px",
    fontSize: 14,
    background: "#2196F3",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    marginLeft: 10,
    flex: 1,
  },
  backBtn: {
    marginTop: 15,
    padding: "10px 20px",
    fontSize: 14,
    background: "transparent",
    color: "#666",
    border: "1px solid #ddd",
    borderRadius: 6,
    cursor: "pointer",
    width: "100%",
  },
  otpActions: {
    display: "flex",
    marginTop: 15,
    gap: 10,
  },
  error: {
    color: "red",
    marginTop: 10,
    fontSize: 14,
  },
  success: {
    color: "#4CAF50",
    marginTop: 10,
    fontSize: 14,
  },
  couponBox: {
    marginTop: 20,
    padding: "15px",
    border: "2px dashed #2e7d32",
    borderRadius: 8,
    cursor: "pointer",
    background: "#f1fff3",
  },
  couponCode: {
    fontSize: 22,
    fontWeight: 700,
    color: "#2e7d32",
    margin: 0,
    textAlign: "center",
    letterSpacing: 1,
  },
  copyHint: {
    display: "block",
    marginTop: 8,
    fontSize: 13,
    color: "#555",
  },
  closeIcon: {
    position: "absolute",
    top: 12,
    right: 14,
    fontSize: 20,
    fontWeight: "bold",
    cursor: "pointer",
    color: "#555",
    userSelect: "none",
  },
};

export default SpinWheel;
